import FlashMessage from '../common/flash-message.component'
import AppConstants from '../constants/app.constants'
import { store } from '../store'
import RouterUtils from './router.util'

export default class AuthUtils {
  /**
   * トークンの有効期限が切れた場合の処理。
   *
   * @param {string} errorMsg エラーメッセージ
   */
  static handleExpiredToken(errorMsg) {
    store.dispatch('auth/logout', { root: true })
    FlashMessage.getInstance().showErrorMessage(errorMsg, false, true)
    RouterUtils.goToRouterPath(AppConstants.LOGIN_URL)
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/auth.util.js